import React, { ReactNode } from "react";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import PreviewIcon from "@mui/icons-material/PreviewOutlined";

import * as Styled from "./ListDetailsPanel.styles";
import { Box, IconButton, Typography } from "@mui/material";
import { DrawerHeader } from "../../DrawerHeader";
import { Translations } from "ui/Scripts/source/models/translations";
import { LocalLoading } from "../../Loading/LocalLoading";

interface IListDetailsPanelProps {
    children: ReactNode;
    onClose: () => void;
    flexGrow?: number;
    maxWidth?: string | number;
    subTitle?: string;
    buttons?: ReactNode;
    isLoading?: boolean;
}

export const ListDetailsPanel = (props: IListDetailsPanelProps) => {
    return (
        <Styled.Container style={{ flexGrow: props.flexGrow, maxWidth: props.maxWidth }}>
            <Box display="flex" flexDirection="column" flexGrow={2} minHeight="100%">
                <DrawerHeader>
                    <Box display="flex" justifyContent="space-between" color="#616d7c" width="100%" position="relative">
                        <Box display="flex" alignItems="center">
                            <div style={{ marginRight: "4px" }}>{<PreviewIcon />}</div>
                            <Typography variant="h6">{Translations.Preview}</Typography>
                            {props.subTitle &&
                                <Typography variant="caption" sx={{ marginLeft: "10px", marginTop: "6px" }}>{props.subTitle}</Typography>
                            }
                        </Box>
                        {!!props.isLoading &&
                            <LocalLoading />
                        }
                        <Box>
                            {props.buttons}
                            <IconButton onClick={props.onClose}>
                                <ClearOutlinedIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DrawerHeader>
                {props.children}
            </Box>
        </Styled.Container>
    );
};
